module.exports = __webpack_public_path__ + "static/media/center-middle.a217bfa8.png";